export default __webpack_public_path__ + "static/media/dr-ruhi.9bffee29.jpg";